/**
 * Titan — keep the Essential Countdown Timer app's own CSS in charge of its bar.
 *
 * The app injects `<style id="countdown_timer">` into <head> at runtime (after
 * it fetches its config). Its title rule
 *   `.countdown_annoucement_bar_title_<id>.h2 { font-size: 14px … }`
 * has the SAME specificity as Horizon's heading utility in base.css
 *   `.h2.h2 { font-size: var(--font-h2--size) … }`   (48px, uppercase, Quantico)
 * so the cascade falls back to source order: whichever stylesheet appears LAST
 * in the document wins. Whenever the theme's stylesheets end up after the app's
 * <style> (e.g. markup that makes the browser close <head> early and push the
 * theme <link>s into <body>), the theme's H2 styling takes over and the
 * countdown title renders huge.
 *
 * Fix: relocate the app's OWN <style> element to the end of <body> whenever it
 * appears, is re-created, or another stylesheet lands after it. Moving the node
 * keeps its id, its CSS text and the app's references intact — nothing is copied
 * or hard-coded, so any change the merchant makes in the app flows through
 * untouched. The app then wins every specificity tie by position alone.
 */
(function () {
  'use strict';

  var STYLE_ID = 'countdown_timer';
  var scheduled = false;
  var moving = false;

  function lastOtherStylesheet(except) {
    var nodes = document.querySelectorAll('link[rel~="stylesheet"], style');
    for (var i = nodes.length - 1; i >= 0; i--) {
      if (nodes[i] !== except) return nodes[i];
    }
    return null;
  }

  function ensureLast() {
    scheduled = false;
    var el = document.getElementById(STYLE_ID);
    if (!el || el.tagName !== 'STYLE' || !document.body) return;

    var last = lastOtherStylesheet(el);
    // Already positioned after every other stylesheet — nothing to do.
    if (!last || el.compareDocumentPosition(last) & Node.DOCUMENT_POSITION_PRECEDING) return;

    moving = true;
    try {
      document.body.appendChild(el); // moves the node; CSS text untouched
      el.setAttribute('data-titan-countdown-priority', '1');
    } finally {
      moving = false;
    }
  }

  function schedule() {
    if (scheduled || moving) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(ensureLast);
  }

  // The app fetches its config asynchronously, so the <style> can show up at any
  // time (and can be re-created when the timer re-renders). Watch the document
  // and re-check on every batch of DOM additions; the check itself is cheap and
  // a no-op once the element is in place.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        schedule();
        return;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
})();
